import { useBaseSWR } from './useBaseSWR';
import fetcherIntuition from '../fetcherIntuition';

const useIntuitionSWR = <T=any,>(endpoint: string | null, swrOptions: any = {}) => {
  return useBaseSWR<T>(endpoint, fetcherIntuition, 'intuition', swrOptions);
};

export default useIntuitionSWR;
